"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var _ = require("lodash");
var UserNotificationsStore = /** @class */ (function () {
    function UserNotificationsStore(socketService) {
        var _this = this;
        this.socketService = socketService;
        this.onUpdateEventCreated = function (data) {
            _this.isLoading = true;
            var idx = _this.items.findIndex(function (item) { return item._id === data._id; });
            if (idx < 0) {
                _this.items.unshift(data);
                _this.updateUnseenNotificationsCount();
            }
            _this.isLoading = false;
        };
        this.onUpdateEventMarkAsSeen = function (data) {
            _this.isLoading = true;
            var idx = _this.items.findIndex(function (item) { return item._id === data._id; });
            _this.markAsSeenReply(data, idx);
            _this.isLoading = false;
        };
        this.onSelectItem = function (selectedItemId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedItemIndex = this.items.findIndex(function (item) { return item._id === selectedItemId; });
                        this.selectedItem = this.items[this.selectedItemIndex];
                        if (!!this.selectedItem.seen) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._markAsSeen()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.onUpdateEventUpdated = function (data) {
            _this.isLoading = true;
            var index = _this.items.findIndex(function (item) { return item._id === data._id; });
            if (_this.selectedItem && (_this.selectedItem._id === _this.items[index]._id)) {
                _this.selectedItem = data;
            }
            _this.items[index] = data;
            _this.updateUnseenNotificationsCount();
            _this.isLoading = false;
        };
        this.reset();
    }
    UserNotificationsStore.prototype.reset = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.loadError = false;
            _this.items = mobx_1.observable.array([]);
            _this.unseenCount = 0;
            _this.selectedItemIndex = 0;
            _this.selectedItem = null;
            _this.itemsByType = {};
            _this.types = [];
            _this.search = "";
        });
    };
    Object.defineProperty(UserNotificationsStore.prototype, "notifications", {
        get: function () {
            return this.items;
        },
        enumerable: true,
        configurable: true
    });
    UserNotificationsStore.prototype.initialize = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onStartListeningUserNotifications()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getItems(userId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserNotificationsStore.prototype.getItems = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.isLoading = true;
                this.socketService.getNotificationsById(userId)
                    .then(mobx_1.action(function (res) { return _this.onLoadItemsSuccess(res); }))
                    .catch(function (err) { return _this.onLoadItemsError(err); });
                return [2 /*return*/];
            });
        });
    };
    UserNotificationsStore.prototype.onStartListeningUserNotifications = function () {
        this.socketService.startListeningUserNotificationsCreated(this.onUpdateEventCreated);
        this.socketService.startListeningUserNotificationsMarkAsSeen(this.onUpdateEventMarkAsSeen);
        this.socketService.startListeningUserNotificationsUpdated(this.onUpdateEventUpdated);
    };
    UserNotificationsStore.prototype.markAllAsRead = function (userId) {
        var _this = this;
        this.socketService.markAllAsSeen(userId)
            .then(mobx_1.action(function () {
            _this._markAll();
        }));
    };
    UserNotificationsStore.prototype.updateUnseenNotificationsCount = function () {
        var unseen = this.items.filter(function (item) { return item.seen === false; });
        this.unseenCount = unseen.length;
    };
    UserNotificationsStore.prototype.onLoadItemsSuccess = function (data) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.items = data.results;
            // this.setItemsByTypes(data.results);
            _this.updateUnseenNotificationsCount();
        });
    };
    UserNotificationsStore.prototype.setItemsByTypes = function (results) {
        for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
            var item = results_1[_i];
            if (this.itemsByType[item.type] && this.itemsByType[item.type].length) {
                this.itemsByType[item.type].push(item);
            }
            else {
                this.types.push(item.type);
                this.itemsByType[item.type] = [item];
            }
        }
    };
    UserNotificationsStore.prototype.onLoadItemsError = function (e) {
        this.isLoading = false;
        this.loadError = true;
    };
    UserNotificationsStore.prototype.markAsSeenReply = function (res, index) {
        if (this.selectedItem && (this.selectedItem._id === this.items[index]._id)) {
            this.selectedItem.seen = res.seen;
        }
        this.items[index].seen = res.seen;
        this.updateUnseenNotificationsCount();
    };
    UserNotificationsStore.prototype._markAsSeen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.socketService.markAsSeen(this.selectedItem._id)];
            });
        });
    };
    UserNotificationsStore.prototype.setSearch = function (str) {
        this.selectedItemIndex = 0;
        this.selectedItem = null;
        this.search = str;
    };
    UserNotificationsStore.prototype.clearSearch = function () {
        this.search = "";
    };
    Object.defineProperty(UserNotificationsStore.prototype, "filteredItems", {
        get: function () {
            var _this = this;
            if (this.items) {
                return _.filter(this.items, function (notification) {
                    return notification.subject && notification.subject.toLowerCase().indexOf(_this.search.toLowerCase()) > -1 || notification.message && notification.message.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    UserNotificationsStore.prototype._markAll = function () {
        this.selectedItem && (this.selectedItem.seen = true);
        this.items.forEach(function (item) { return item.seen = true; });
        this.unseenCount = 0;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "items", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "itemsByType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "loadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "unseenCount", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "selectedItemIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "selectedItem", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "search", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserNotificationsStore.prototype, "types", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserNotificationsStore.prototype, "notifications", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "initialize", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "getItems", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "markAllAsRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "updateUnseenNotificationsCount", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "onLoadItemsSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "setItemsByTypes", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "onLoadItemsError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "onUpdateEventCreated", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "onUpdateEventMarkAsSeen", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "onSelectItem", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "markAsSeenReply", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "_markAsSeen", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "setSearch", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "clearSearch", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserNotificationsStore.prototype, "filteredItems", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "onUpdateEventUpdated", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserNotificationsStore.prototype, "_markAll", null);
    return UserNotificationsStore;
}());
exports.default = UserNotificationsStore;
